// UI Constants
// Centralized UI configuration values used across the application

// Drawer dimensions
export const DRAWER_WIDTH = 240;
export const COLLAPSED_WIDTH = 56;

// Chart dimensions
export const BAR_HEIGHT = 28;
export const MIN_CHART_HEIGHT = 300;

// Timing
export const DEBOUNCE_DELAY_MS = 1000;

// Pagination options by task type
export const PAGE_SIZE_OPTIONS = {
  mmc: [10, 20, 50, 100],
  detection: [20, 50, 100, 200],
  plate: [10, 20, 50, 100, 200],
} as const;

export const DEFAULT_PAGE_SIZE = {
  mmc: 20,
  detection: 20,
  plate: 20,
} as const;
